import React, {Component} from 'react';
import {Document, Page, pdfjs} from "react-pdf";
import Glide from '@glidejs/glide';

// Serve the pdf.js worker as a static file (public/pdf.worker.min.js, copied from
// pdfjs-dist 2.1.266, the version react-pdf 4.2 uses). The bundled worker from
// "react-pdf/dist/entry.webpack" crashes under this webpack config
// ("window is not defined"), which left every PDF stuck on "Loading".
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ""}/pdf.worker.min.js`;

const leftArrow = <svg
  xmlns="http://www.w3.org/2000/svg"
  fill="#FFFFFF"
  width="36"
  height="36"
  viewBox="0 0 18 18"><path d="M11.56 5.56L10.5 4.5 6 9l4.5 4.5 1.06-1.06L8.12 9z"/></svg>
const rightArrow = <svg
  xmlns="http://www.w3.org/2000/svg"
  fill="#FFFFFF"
  width="36"
  height="36"
  viewBox="0 0 18 18"><path d="M7.5 4.5L6.44 5.56 9.88 9l-3.44 3.44L7.5 13.5 12 9z"/></svg>

const isBrowser = () => typeof window !== 'undefined' && window.document !== undefined;

class BookMultiPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      numPages: null,
      pageNumber: 1,
      padding: 4,
      ratingValue: 0
    };
    this.onDocumentLoadSuccess = ({numPages}) => {
      // If the slider was on a previous document's DOM, start fresh for this one.
      this.destroyGlide();
      this.setState({numPages});
    }
    this.zoomPage = (ev) => {}
    this.onRatingChange = ratingValue => {
      this.setState({ratingValue})
    }
  }

  // Fit the page to the current window: by height on wide screens, by width on narrow ones.
  computeSize() {
    let docRatio = this.props.docRatio||0.63333; //default is potrait
    var w = window.innerWidth * 0.92;
    var h = window.innerHeight;
    if (w / h >= docRatio) {
      return { width: (h * docRatio), height: h };
    }
    return { width: w, height: w / docRatio - 48 };
  }

  componentWillMount() {
    if (isBrowser()) {
      this.setState(this.computeSize());
    }
  }

  componentDidMount() {
    // Re-fit on resize / phone rotation (debounced so dragging a window edge stays smooth).
    this.onResize = () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.setState(this.computeSize()), 200);
    };
    window.addEventListener('resize', this.onResize);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      // A different document: drop the old slider; a new one is mounted once it loads.
      this.destroyGlide();
      return;
    }
    if (this.state.numPages > 0) {
      if (!this.glide) {
        // Mount the slider once per document (it used to be re-created on every update).
        const glide = new Glide(this.glideEl, {perView: 1});
        glide.on('run', () => {
          const current = document.getElementById('current-page');
          if (current) {
            current.innerHTML = glide.index + 1;
          }
        });
        glide.mount();
        this.glide = glide;
      } else {
        // Same slider, new page sizes: let it re-measure.
        this.glide.update();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    clearTimeout(this.resizeTimer);
    this.destroyGlide();
  }

  destroyGlide() {
    if (this.glide) {
      this.glide.destroy();
      this.glide = null;
    }
  }

  render() {
    const { duringLoad, src } = this.props;
    const { numPages, width, height, padding, ratingValue } = this.state;
    if (isBrowser()) {
      return (
        <div className='_book-cntr'>
          <Document
            loading={duringLoad}
            error={<div className='loading-screen'>Sorry, this document could not be loaded. Please try again later.</div>}
            className='document-cntr'
            file={src}
            onLoadSuccess={this.onDocumentLoadSuccess}>
            <div className="glide" ref={el => { this.glideEl = el; }}>
              <div className="glide__track" data-glide-el="track">
                <ul className="glide__slides">
                  {populatePages(numPages, width, height, padding, {ratingValue, onRatingChange: this.onRatingChange})}
                </ul>
              </div>
              <div
                className="glide__arrows"
                data-glide-el="controls"
                style={{
                width
              }}>
                <button className="glide__arrow glide__arrow--left" data-glide-dir={"<"}>{leftArrow}</button>
                <button className="glide__arrow glide__arrow--right" data-glide-dir={">"}>{rightArrow}</button>
              </div>
            </div>
            <div className="page-numbers">
              <span id='current-page'>1</span>/<span id='number-of-pages'>{numPages}</span>
            </div>
            {/* <div className="zoom-controls">
              <span id='zoom-up'>+</span>/<span id='zoom-down'>-</span>
            </div> */}
          </Document>
        </div>
      )
    }
    return null;
  }
}

function populatePages(numPages, width, height, padding, feedback) {
  let canvasWidth = width - 2 * padding;
  let array_pages = [];
  for (let i = 1; i <= numPages; i++) {
    array_pages.push(
      <li
        key={'pg-' + i}
        className='page-cntr glide__slide'
        style={{
        width,
        height
      }}><Page
        pageNumber={i}
        width={canvasWidth}
        renderTextLayer={false}
        onRenderSuccess={() => {}}/></li>
    )
  };
  return array_pages;
}

export default BookMultiPage;